export default "__VITE_PUBLIC_ASSET__6dab6fe9__"